const theme = {
  colors: {
    darkBlue: '#0065B2',
    lightBlue: '#00ACEE',
    white: '#fff',
    black: '#181424',
    greyDark: '#4D4D4D',
    greyLight: '#f4f2f2',
    greyLightBg: '#EDF2F4',
    greyBlue: '#a2bce2',
    grey: '#595C62',
    greyDarker: '#1c252b',
    red: '#F83463',
    opaqueBlue: '#2265B155',
    footer: '#171421',
    orange: '#F09F49'
  },
  transitionDuration: '0.4s',
  maxWidth: '1170px',
  maxWidthText: '720px',
  leftMargin: '5%',
  rightMargin: '5%',
  breakpoints: {
    xs: '400px',
    s: '600px',
    m: '900px',
    l: '1200px',
  },
};

export default theme;
